import CurrentSample from './currentSample'
import { connect }  from 'react-redux'

const mapStateToProps = ( state, props ) => ({
	tile: state.tiles[state.selectedTile],
	colors: state.currentColors
})

const VisibleCurrentSample = connect (mapStateToProps, null)(CurrentSample);

export default VisibleCurrentSample;


// WEBPACK FOOTER //
// ./src/components/mosaic/visibleCurrentSample.jsx